// extracted by mini-css-extract-plugin
export default {"user":"profileIcon_user__HRvSz","separator":"profileIcon_separator__OFZ5T","exit":"profileIcon_exit__OEAwY"};